import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import download from '../images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import { Grid, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import ReportsAGGrid from "../reportsGrid/reportsAGGrid";
import CloseIcon from '@mui/icons-material/Close';

const styles = theme => ({
    root: {
        width: "100%",
    },
    spinner: {
        position: 'absolute',
        background: 'rgba(255,255,255,.4)',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        top: 0,
        left: 0,
    },
    spinnerImage: {
        top: 'calc(50% - 32.5px)',
        left: 'calc(50% - 65px)',
        position: 'absolute',
        width: '130px',
        userSelect: 'none'
    },
});

const TransactionSortObj = {
    firstname: { tableName: '', sortColumn: 'first_name' },
    lastname: { tableName: '', sortColumn: 'last_name' },
    store: { tableName: 'accounts', sortColumn: 'name' },
    box: { tableName: 'boxes', sortColumn: 'name' },
    member_number: { tableName: '', sortColumn: 'member_number' },
    id_number: { tableName: '', sortColumn: 'id_number' },
    smsphone: { tableName: '', sortColumn: 'smsphone' },
    email: { tableName: '', sortColumn: 'email' },
    dob_str: { tableName: '', sortColumn: 'dob_str' },
    created_on: { tableName: '', sortColumn: 'created_on' },
}

let TransactionFilterObj = {
    store_ids: [],
    box_ids: [],
    searchObject: null,
    fromdate: '',
    todate: '',
    pageNo: 0,
    pageSize: 25,
    sortOrder: 'desc',
    sortColumn: 'created_on',
    tableName: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rowsPerPage: 25,
            boxvalues: [],
            accountValues: [],
            loader: false,
            selectedObject: null,
            selectedTab: 0,
            isButtonDisabled: false,
            data: []
        };
    }

    componentDidMount() {
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + "accounts", {
            method: 'GET',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            }
        }).then(response => response.json()).then(accounts => {
            const storelist = accounts.map(account => {
                return { id: account.id, name: account.name };
            });
            this.setState({ accountValues: storelist, parent_account_id: storelist[0].id });
            this.BindBoxesbyStoreId(storelist.map(x => x.id));
            this.setState({ loader: false });
        });
    }

    convertToTimeZone = (requestDate) => {
        const currentUserLang = localStorage.getItem('i18nextLng');
        let zone;
        zone = sessionStorage.getItem('timeZone');
        const date = moment(new Date(requestDate));
        if (['null', null, 'undefined', undefined].includes(zone)) {
            zone = defaultZone;
        }
        return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
    }


    exportCSV() {
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + 'CSV/LoyaltyMemberReport', {
            method: 'POST',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(TransactionFilterObj)
        })
            .then(response => {
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            })
            .then(csvData => {
                this.setState({ loader: false });
                let csvRow = [];
                let Array = [['Id', 'MemberId', 'IDNumber', 'FirstName', 'LastName', 'Store', 'Box', 'Phone', 'Email', 'DOB', 'Enroll Date/Time']];
                let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
                if (result !== undefined && result !== 'undefined') {
                    if (result && result.length > 0) {
                        for (let i of result) {
                            Array.push(
                                [
                                    i.member_number,
                                    i.id_number,
                                    i.firstname,
                                    i.lastname,
                                    i.store,
                                    i.box,
                                    i.smsphone,
                                    i.email,
                                    i.dob_str,
                                    i.created_on ? this.convertToTimeZone(i && i.created_on) : '',
                                ]
                            );
                        }

                        for (let i of Array) {
                            csvRow.push(i.join(","));
                        }
                        let csvString = csvRow.join("%0A");
                        let element = document.createElement("a");
                        element.href = 'data:attachment/csv.' + csvString;
                        element.target = "_Blank";
                        element.download = "LoyaltyMambersReport.csv";
                        document.body.appendChild(element);
                        element.click();
                    }
                }
            })
    }

    //Bind Boxes by store id
    BindBoxesbyStoreId(store_ids) {
        if (store_ids.length > 0) {
            this.setState({ loader: true });
            let BoxesObj = {
                store_ids: store_ids
            }
            fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
                method: 'post',
                withCredentials: true,
                headers: {
                    'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(BoxesObj)
            }).then(response => {
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            }).then(data => {
                const boxlist = data.map(account => {
                    return { id: account.id, name: account.name };
                });
                this.setState({ boxvalues: boxlist });
                this.setState({ loader: false });
            });
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api
        const datasource = this.getServerSideDatasource(this.state.boxvalues, this.state.accountValues)
        // register datasource with the grid
        this.gridApi.setServerSideDatasource(datasource);
    }

    clearFilters = () => {
        const filterModel = this.gridApi.getFilterModel();
        if (Object.keys(filterModel).length > 0) {
            this.gridApi.setFilterModel(null);
            TransactionFilterObj.searchObject = null;
            TransactionFilterObj.box_ids = [];
            TransactionFilterObj.store_ids = [];
            TransactionFilterObj.fromdate = '';
            TransactionFilterObj.todate = '';
            this.gridApi.refreshServerSide();
        }
    };

    getServerSideDatasource = (boxvalues, accountValues) => {
        const self = this;
        return {
            getRows(params) {
                TransactionFilterObj.pageNo = Math.floor(params.request.startRow / self.state.rowsPerPage)

                const filterObject = params.request && params.request.filterModel
                const filterColumns = Object.keys(filterObject)

                // to set box_ids
                if (filterObject.box) {
                    const filterValues = filterObject.box.values;
                    if (filterValues.length > 0) {
                        TransactionFilterObj.box_ids = boxvalues.filter(boxes => {
                            return filterValues.includes(boxes.name)
                        }).map(box => box.id)
                    }
                } else {
                    TransactionFilterObj.box_ids = []
                }

                // to set store_ids
                if (filterObject.store) {
                    const filterValues = filterObject.store.values;
                    TransactionFilterObj.store_ids = accountValues.filter(accounts => {
                        return filterValues.includes(accounts.name)
                    }).map(store => store.id)
                } else {
                    TransactionFilterObj.store_ids = []
                }

                // to set fromdate and todate
                if (filterObject.created_on) {
                    const dateValue = filterObject.created_on;
                    if (dateValue.operator) {
                        // for date range
                        if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
                            const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
                            const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
                            TransactionFilterObj.fromdate = date1
                            TransactionFilterObj.todate = date2
                        }
                        if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
                            const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
                            const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
                            TransactionFilterObj.fromdate = date1
                            TransactionFilterObj.todate = date2
                        }
                    } else {
                        // for from/to date
                        const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
                        if (dateValue.type === 'fromdate') {
                            TransactionFilterObj.fromdate = date
                            TransactionFilterObj.todate = ''
                        } else {
                            TransactionFilterObj.todate = date
                            TransactionFilterObj.fromdate = ''
                        }
                    }
                } else {
                    TransactionFilterObj.todate = '';
                    TransactionFilterObj.fromdate = ''
                }

                if (filterObject) {
                    if (filterColumns.length === 0) {
                        TransactionFilterObj.searchObject = null
                    } else {
                        TransactionFilterObj.searchObject = filterObject
                    }
                }

                if (params.request.sortModel.length > 0) {
                    TransactionFilterObj.tableName = TransactionSortObj[params.request.sortModel[0].colId].tableName
                    TransactionFilterObj.sortColumn = TransactionSortObj[params.request.sortModel[0].colId].sortColumn
                    TransactionFilterObj.sortOrder = params.request.sortModel[0].sort
                }

                const isStoreNotSelected = Boolean(filterObject.store && filterObject.store.values.length === 0)
                const isBoxNotSelected = Boolean(filterObject.box && filterObject.box.values.length === 0)

                if (isStoreNotSelected === true || isBoxNotSelected === true) {
                    // store or box is not selected, so empty data
                    params.successCallback([], 0)
                    self.setState({ data: [], isButtonDisabled: true })
                } else { // store or box is selected
                    apiCall()
                }

                function apiCall() {
                    self.setState({ loader: true });
                    fetch(process.env.REACT_APP_BASEURL + 'loyalty-members', {
                        method: 'post',
                        withCredentials: true,
                        headers: {
                            Authorization:
                                'Bearer ' +
                                JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                                    .jwtToken,
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(TransactionFilterObj),
                    })
                        .then((httpResponse) => {
                            try {
                                return httpResponse.json();
                            } catch (error) {
                                return null;
                            }
                        })
                        .then((response) => {
                            if (response && response.results) {
                                if (response.results.length > 0) {
                                    params.successCallback(response.results, response.total);
                                    self.setState({ data: response.results, isButtonDisabled: false })
                                } else {
                                    params.successCallback([], 0);
                                    self.setState({ data: [], isButtonDisabled: true })
                                }
                                self.setState({ loader: false })
                            }
                        })
                        .catch(error => {
                            self.setState({ loader: false })
                            console.error(error);
                            params.failCallback();
                        });
                }
            }
        };
    }

    DateCellFormatter = (params) => {
        return this.convertToTimeZone(params.value)
    }

    render() {
        const { classes, t } = this.props;
        const { data, accountValues, boxvalues } = this.state;

        const columnDefs = [
            { field: "member_number", headerName: t("Report.Loyalty.MemberOrLoyaltyNumber") },
            { field: "id_number", headerName: t("Report.Loyalty.IDNumber") },
            { field: "firstname", headerName: t("Report.Loyalty.FirstName"), },
            { field: "lastname", headerName: t("Report.Loyalty.LastName") },
            {
                field: "store", headerName: t("Report.Loyalty.Store"), filter: true,
                filterParams: {
                    values: accountValues.map(account => {
                        return account.name
                    })
                },
                menuTabs: ['generalMenuTab', 'columnsMenuTab'],
            },
            {
                field: "box", headerName: t("Report.Loyalty.Box"), filter: true,
                filterParams: {
                    values: boxvalues.map(box => {
                        return box.name
                    })
                },
                menuTabs: ['generalMenuTab', 'columnsMenuTab'],
            },
            { field: "smsphone", headerName: t("Report.Loyalty.Phone"), cellRenderer: this.TransactionStatusRenderer },
            { field: "email", headerName: t("Report.Loyalty.Email"), cellRenderer: this.CardNumberRenderer },
            { field: "dob_str", headerName: t("Report.Loyalty.DateOfBirth") },
            {
                field: "created_on", headerName: t("Report.Loyalty.EnrollDateTime"),
                cellRenderer: this.DateCellFormatter,
                filter: 'agDateColumnFilter',
                filterParams: {
                    filterOptions: [
                        {
                            displayKey: 'fromdate',
                            displayName: t('Report.Loyalty.FromDate'),
                            predicate: (_, cellValue) => cellValue
                        },
                        {
                            displayKey: 'todate',
                            displayName: t('Report.Loyalty.ToDate'),
                            predicate: (_, cellValue) => cellValue
                        },
                    ],
                    maxNumConditions: 2,
                },
            },
        ];

        return (
            <Paper id="react-no-print" className={classes.root}>
                {
                    this.state.loader ?
                        <div className={classes.spinner}>
                            <img className={classes.spinnerImage} src={spinner} alt="loading" />
                        </div> :
                        null
                }
                <div id="react-no-print">
                    <Box component="div">
                        <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={0} sx={{ ml: 0, mr: 1, width: '100%', border: 'solid 1px #babfc7', borderBottom: 'none' }}>
                            <Grid item xs={3} md={3} sx={{ textAlign: 'end' }}>
                                <Tooltip key="clear-filters" title={t("Report.Loyalty.ClearFiltersTooltip")}>
                                    <IconButton onClick={() => this.clearFilters()} style={{ backgroundColor: "#00a7e1" }}>
                                        <CloseIcon style={{ color: "white" }} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip key="export-csv" title={t("Report.Loyalty.ExportCSVTooltip")}>
                                    <IconButton
                                        style={{ marginRight: '0' }}
                                        aria-label="ExportCSV"
                                        disabled={this.state.isButtonDisabled}
                                    >
                                        <img alt="download" onClick={() => { this.exportCSV() }} src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Box>
                    {accountValues.length && boxvalues.length ?
                        <ReportsAGGrid
                            columnDefs={columnDefs}
                            sideBar={false}
                            suppressMenuHide={true}
                            rowData={data}
                            defaultColDef={{
                                flex: 1,
                                minWidth: 150,
                                floatingFilter: true,
                                filter: 'agTextColumnFilter',
                                filterParams: {
                                    filterOptions: [{
                                        displayKey: 'searchtext',
                                        displayName: 'Search Text',
                                        predicate: (cellValue) => cellValue
                                    }],
                                    maxNumConditions: 1,
                                },
                                resizable: true,
                                sortable: true,
                                menuTabs: ['generalMenuTab', 'columnsMenuTab'],
                            }}
                            onGridReady={this.onGridReady}
                        />
                        : null
                    }
                </div>
            </Paper>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/loyalty-members/index.js